import BlogCreate from "components/Cards/BlogCreate";
import React from "react";


export default function CreateBlog() {
  return (
    <>
      <div className="flex flex-wrap mt-4">
        <div className="w-full mb-12 px-4">
          <BlogCreate />
        </div>
      </div>
    </>
  );
}
